import React from 'react';
import { PolicyMakerNavProvider } from '../context/PolicyMakerNavContext';
import Navbar from '../components/Navbar';
import PolicyMakerPage from '../pages/PolicyMakerPage';

/** Wraps /policy-maker so Navbar and workspace share edit-profile state via context */
const PolicyMakerRouteLayout = () => (
  <PolicyMakerNavProvider>
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-200 w-full">
      <Navbar />
      <main className="critical-minerals-dashboard-main w-full">
        <PolicyMakerPage />
      </main>
    </div>
  </PolicyMakerNavProvider>
);

export default PolicyMakerRouteLayout;
